import { CommonEnums } from '../../common.enums';

export class Conn_Db {
    conn_Id: number;
    conn_Db_Id: number;
    nm: string;
    description: string;
    databaseNm: string;
    dbParamNm: string;
    schemaNm: string;
    schemaParamNm: string;
    stgDb_Flag: string;
    srt_Order: number;
    schemaList: Array<any>;
    updateDt: Date;
    updateBy: string;
    ref_Id: number;

    datasetsList: Array<string>;

    constructor() {
        this.setDefaults();

    }

    static parse(object: any): Conn_Db {
        let conn_Db: Conn_Db = new Conn_Db();
        conn_Db.copyFrom(object as Conn_Db)
        return conn_Db;
    }

    setDefaults() {
        this.conn_Id = CommonEnums.defaults.LONG_VAL;
        this.conn_Db_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.databaseNm = CommonEnums.defaults.STRING_EMPTY;
        this.dbParamNm = CommonEnums.defaults.STRING_EMPTY;
        this.schemaNm = CommonEnums.defaults.STRING_EMPTY;
        this.schemaParamNm = CommonEnums.defaults.STRING_EMPTY;
        this.stgDb_Flag = CommonEnums.defaults.STRING_VAL_NO
        this.srt_Order = CommonEnums.defaults.LONG_VAL;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.datasetsList = new Array<string>();
        this.schemaList = new Array<any>();
    }
    getPrimaryKey(): string {
        return this.conn_Id + '.' + this.conn_Db_Id;
    }


    copy(): Conn_Db {
        let conn_DbTmp: Conn_Db = new Conn_Db();

        conn_DbTmp.conn_Id = this.conn_Id;
        conn_DbTmp.conn_Db_Id = this.conn_Db_Id;
        conn_DbTmp.nm = this.nm;
        conn_DbTmp.description = this.description;
        conn_DbTmp.databaseNm = this.databaseNm;
        conn_DbTmp.dbParamNm = this.dbParamNm;
        conn_DbTmp.schemaNm = this.schemaNm;
        conn_DbTmp.schemaParamNm = this.schemaParamNm;
        conn_DbTmp.stgDb_Flag = this.stgDb_Flag;
        conn_DbTmp.srt_Order = this.srt_Order;
        conn_DbTmp.updateDt = this.updateDt;
        conn_DbTmp.updateBy = this.updateBy;
        conn_DbTmp.ref_Id = this.ref_Id;
        conn_DbTmp.datasetsList = this.datasetsList;
        conn_DbTmp.schemaList = this.schemaList;

        return conn_DbTmp;
    }

    copyFrom(conn_DbTmp: Conn_Db): void {
        this.conn_Id = conn_DbTmp.conn_Id;
        this.conn_Db_Id = conn_DbTmp.conn_Db_Id;
        this.nm = conn_DbTmp.nm;
        this.description = conn_DbTmp.description;
        this.databaseNm = conn_DbTmp.databaseNm;
        this.dbParamNm = conn_DbTmp.dbParamNm;
        this.schemaNm = conn_DbTmp.schemaNm;
        this.schemaParamNm = conn_DbTmp.schemaParamNm;
        this.stgDb_Flag = conn_DbTmp.stgDb_Flag;
        this.srt_Order = conn_DbTmp.srt_Order;
        this.updateDt = conn_DbTmp.updateDt;
        this.updateBy = conn_DbTmp.updateBy;
        this.ref_Id = conn_DbTmp.ref_Id;
        this.datasetsList = conn_DbTmp.datasetsList;
        this.schemaList = conn_DbTmp.schemaList;
    }

    compare(Conn_DbTmp: Conn_Db): string {
        let Conn_DbString: string = this.toString(false);
        let Conn_DbTmpString: string = Conn_DbTmp.toString(false);

        if (Conn_DbString != Conn_DbTmpString) {
            return Conn_DbString + ', ' + Conn_DbTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Conn_Db [conn_Id=" + this.conn_Id + ", conn_Db_Id=" + this.conn_Db_Id +
            ", nm=" + this.nm + ", description=" + this.description + ", databaseNm=" + this.databaseNm +
            ", dbParamNm=" + this.dbParamNm + ", schemaNm=" + this.schemaNm + ", schemaParamNm=" + this.schemaParamNm +
            ", stgDb_Flag=" + this.stgDb_Flag + ", srt_Order=" + this.srt_Order + ", updateDt=" + this.updateDt +
            ", updateBy=" + this.updateBy;

        if (isNotCompare) {
            str += ", datasetsList=" + this.datasetsList +
                ",  ref_Id=" + this.ref_Id;
        }

        str += ']';

        return str;
    }
}
